import { ODataObject } from '../../interfaces/odata-model.interface';
import { TextModel } from '../primitive/text.model';
import { ArrayModel } from './array.model';
import { CompositeModel } from './composite.model';

export class MaterialBillableChangeableModel extends CompositeModel {
    public material: TextModel;
    public billable: TextModel;
    public changeable: TextModel;
    public quantity: TextModel;
    public constructor(material: string, billable: string, changeable: string, quantity = '1') {
        super('MaterialBillableChangeableModel');
        this.material = <TextModel>this.set(new TextModel('Material', material));
        this.billable = <TextModel>this.set(new TextModel('Billable', billable));
        this.changeable = <TextModel>this.set(new TextModel('Changeable', changeable));
        this.quantity = <TextModel>this.set(new TextModel('Quantity', quantity.toString()));
    }
}

export class MaterialBillingIndicatorModel extends CompositeModel {
    public notificationNo: TextModel;
    public taskNumber: TextModel;
    public jobRole: TextModel; // 'CSE or APPS'
    public materialBillingChangeable: ArrayModel<MaterialBillableChangeableModel>;
    public constructor(
        notificationNo: string,
        taskNumber: string,
        jobRole: string,
        matBillChange: MaterialBillableChangeableModel[] = [],
    ) {
        super('MaterialBillingIndicatorModel');
        this.notificationNo = <TextModel>this.set(new TextModel('NotificationNo', notificationNo));
        this.taskNumber = <TextModel>this.set(new TextModel('TaskNumber', taskNumber));
        this.jobRole = <TextModel>this.set(new TextModel('JobRole', jobRole));

        this.materialBillingChangeable = <ArrayModel<MaterialBillableChangeableModel>>(
            this.set(new ArrayModel<MaterialBillableChangeableModel>('MatBillChangeSet', matBillChange))
        );
    }

    public getOutModel(): ODataMaterialBillingIndicatorModel {
        return <ODataMaterialBillingIndicatorModel>super.getOutModel();
    }

    public static fromOdata(data: ODataMaterialBillingIndicatorModel): MaterialBillingIndicatorModel {
        return new MaterialBillingIndicatorModel(
            data.NotificationNo,
            data.TaskNumber,
            data.JobRole,
            data.MatBillChangeSet.results.map(
                (mat) => new MaterialBillableChangeableModel(mat.Material, mat.Billable, mat.Changeable, mat.Quantity),
            ),
        );
    }
}

export interface ODataMaterialBillingIndicatorModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    NotificationNo: string;
    TaskNumber: string;
    JobRole: string;
    MatBillChangeSet: { results: OdataMaterialBillableChangeableModel[] };
}

export interface OdataMaterialBillableChangeableModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    Material: string;
    Billable: string;
    Changeable: string;
    Quantity: string;
}
